import useInView from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const Intro = () => {
  const [ref, inView] = useInView(0.2);
  const { t } = useLanguage();

  return (
    <section data-testid="intro-section" className="bg-cream pt-0 pb-20 md:pb-28">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center" ref={ref}>
        <div className={`reveal ${inView ? 'visible' : ''}`}>
          <span className="section-label">{t.intro.label}</span>
          <div className="hr-gold mt-4 mb-8" />
        </div>

        <p
          className={`reveal reveal-delay-1 font-heading font-light text-obsidian leading-tight ${inView ? 'visible' : ''}`}
          style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.8rem)' }}
        >
          {t.intro.heading}
        </p>

        <p className={`reveal reveal-delay-2 font-body text-winery-text mt-6 max-w-2xl mx-auto text-base md:text-lg leading-relaxed ${inView ? 'visible' : ''}`}>
          {t.intro.body}
        </p>
      </div>
    </section>
  );
};

export default Intro;
